import { EVisitType, LimitedNotesSelector } from '@giffgaff/broadband-common'

export type InstallExtraInfoCardProps = {
  variant?: EVisitType.IN_HOME | EVisitType.PRE_WORK
  legacyNotes?: string
  selectedNotes?: string[]
  setSelectedNotes: (field: string, value: string[]) => void
}

export const InstallExtraInfoCard = ({
  variant,
  legacyNotes,
  selectedNotes,
  setSelectedNotes,
}: InstallExtraInfoCardProps) => {
  const title = variant === EVisitType.IN_HOME ? 'Home install Extra info' : 'Outside install Extra info'

  return (
    <LimitedNotesSelector
      fieldName="selectedNotes"
      legacyNotes={legacyNotes}
      selectedNotes={selectedNotes}
      setValue={setSelectedNotes}
      showChatInfo={true}
      title={title}
    />
  )
}

export default InstallExtraInfoCard
